// extracted by mini-css-extract-plugin
export var menuIcon = "_nb-0";
export var menuIconInline = "_nb-1";